import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";

let faceTrackerForSmallerFace :  THREE.Group;

export function initFaceTrackerForSmallerFace(scene : THREE.Scene){
    faceTrackerForSmallerFace = new THREE.Group();
    scene.add(faceTrackerForSmallerFace);
    faceTrackerForSmallerFace.visible = false;
    return faceTrackerForSmallerFace;
}

export function faceTrackerForSmallerFaceUpdates(faceTrackerGroup : ZapparThree.FaceAnchorGroup){
    faceTrackerForSmallerFace.position.set(faceTrackerGroup.position.x/2,faceTrackerGroup.position.y/2, faceTrackerGroup.position.z)
    faceTrackerForSmallerFace.rotation.copy(faceTrackerGroup.rotation)
    faceTrackerForSmallerFace.scale.copy(faceTrackerGroup.scale)
}


export function revealFaceTrackerForSmallerFace(){
    faceTrackerForSmallerFace.visible = true;
}

export function hideFaceTrackerForSmallerFace(){
    faceTrackerForSmallerFace.visible = false;
}